// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"logo-navigator_wrapper__1czDn","textFieldWrapper":"logo-navigator_textFieldWrapper__2QpNB"};